function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.3333 1.99996H14C14.1768 1.99996 14.3464 2.0702 14.4714 2.19522C14.5964 2.32025 14.6667 2.48981 14.6667 2.66663V13.3333C14.6667 13.5101 14.5964 13.6797 14.4714 13.8047C14.3464 13.9297 14.1768 14 14 14H2.00001C1.8232 14 1.65363 13.9297 1.52861 13.8047C1.40358 13.6797 1.33334 13.5101 1.33334 13.3333V2.66663C1.33334 2.48981 1.40358 2.32025 1.52861 2.19522C1.65363 2.0702 1.8232 1.99996 2.00001 1.99996H4.66668V0.666626H6.00001V1.99996H10V0.666626H11.3333V1.99996ZM2.66668 5.99996V12.6666H13.3333V5.99996H2.66668ZM4.00001 8.66663H7.33334V11.3333H4.00001V8.66663Z",
  fill: "#333333"
});

var SvgCalendarEventFill = function SvgCalendarEventFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCalendarEventFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-event-fill.996dc444.svg";
export { ForwardRef as ReactComponent };